import { Component, Inject, OnInit } from '@angular/core';
import { VideoPlayerComponent } from '../video-player/video-player.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Video } from '../../models/video';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MediaLibraryService } from '../../services/media-library/media-library.service';
import { MatFormFieldComponent } from '../mat-form-field/mat-form-field.component';
import { PipesModule } from '../../pipes/pipes.module';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';
import { LanguageSelectorService } from '../../services/language-selector/language-selector.service';
import { Language } from '../../utils/language';
import { AuthService } from '../../services/auth/auth.service';
import { SpinnerService } from '../../services/spinner/spinner.service';
import { SearchBarComponent } from '../search-bar/search-bar.component';
import { TranslateService } from '@ngx-translate/core';
import { MediaLibraryFile } from '../../enums/mediaLibraryFileType.enum';
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component';
import { MEDIA_FILE_TYPE_TO_STRING } from '../../utils/utils';
import { FormsModule } from '@angular/forms';
import { getFileNameExtension } from '@pineapplelab/util';
import { TextFieldModule } from '@angular/cdk/text-field';

@Component({
  selector: 'app-player-media',
  standalone: true,
  imports: [
	VideoPlayerComponent,
	MatIconModule,
	MatIcon,
	MatIconButton,
	MatFormFieldComponent,
	PipesModule,
	MaterialModule,
	CommonModule,
	SearchBarComponent,
	PdfViewerComponent,
	FormsModule,
	TextFieldModule
  ],
  templateUrl: './player-media.component.html',
  styleUrl: './player-media.component.scss'
})
export class PlayerMediaComponent implements OnInit {

	isEdit: boolean = false;
	model: Video = new Video();
	languages: Language[] = [];
	filteredLanguages: Language[] = [];
	openLanguages: boolean = false;
	MediaFileType = MediaLibraryFile;
	mediaTypeToString = MEDIA_FILE_TYPE_TO_STRING;
	originalName: string = this.model?.fileName;
	originalDescription: string = this.model?.description;

	constructor(
	  @Inject(MAT_DIALOG_DATA) public data: Video,
	  private authService: AuthService,
	  private matDialogRef: MatDialogRef<PlayerMediaComponent>,
	  private mediaLibraryService: MediaLibraryService,
	  private languageSelectorService: LanguageSelectorService,
	  private spinnerService: SpinnerService,
	  private translateService: TranslateService
	) {}

	ngOnInit(): void {
	  this.model = this.data;
	  this.model.__fileExtension = getFileNameExtension(this.model?.fileName);
	  this.originalName = this.model.fileName;
	  this.originalDescription = this.model.description;
	  this.languageSelectorService.getLanguages().subscribe(data => {
		this.languages = data;
		this.filteredLanguages = data;
	  });
	}

	searchInLanguges(ev: string) {
	  const translationKeys = this.languages.map(lang => lang.name);
	  this.translateService.get(translationKeys).subscribe(translations => {
		this.filteredLanguages = this.languages.filter(language => {
		  const translatedName = translations[language.name].toLowerCase();
		  return translatedName.startsWith(ev.toLowerCase());
		});
	  });
	}

	close() {
	  this.model.fileName = this.originalName;
	  this.model.description = this.originalDescription;
	  this.matDialogRef.close();
	}

	edit() {
	  this.isEdit = true;
	}

	editLanguage() {
	  this.openLanguages = !this.openLanguages;
	}

	selectLanguage(lang: Language) {
	  this.model.language = lang;
	  this.openLanguages = false;
	}

	async save() {
	  this.spinnerService.show();
	  await this.mediaLibraryService.saveEdit(this.authService.projectId, this.model);
	  setTimeout(() => {
		this.matDialogRef.close();
		this.spinnerService.hide();
	  }, 500);
	}

	confirmFileName(element: Video): void {
		element.__editFileNameTitle = false;
		if (!element?.fileName?.trim() || element?.fileName?.trim() === `.${element?.__fileExtension}`) {
			element.fileName = 'media';
		}
		if (element.fileName.endsWith(`.${element.__fileExtension}`)) {
			return;
		}
		element.fileName = `${element.fileName.trim()}.${element.__fileExtension ?? getFileNameExtension(element?.fileName)}`;
	}
  }
